import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { createSelectedItemsSlice } from './actions';
import { SelectedItemsStore } from './types';
import { ZustandStores } from '../../utils';
import { createIndexedDBStorage } from '../../utils/indexedDBAdapter';

export const useSelectedItemsStore = create<SelectedItemsStore>()(
  persist(
    (set, get, store) => ({
      ...createSelectedItemsSlice(set, get, store),
    }),
    {
      name: ZustandStores.SELECTED_ITEMS,
      storage: createJSONStorage(() => createIndexedDBStorage()),
    },
  ),
);
